declare let piiHandler: any;

export function savePii(serviceId: string) {
  'use strict';
  const sessionStorageKey = piiHandler.setSessionStorageData(
    JSON.stringify({ serviceId: serviceId || '' }),
  );
  sessionStorage.setItem('mprdPiiKey', sessionStorageKey);
}

export function getPiiServiceId() {
  'use strict';
  const data = sessionStorage.getItem(sessionStorage.getItem('mprdPiiKey'));
  if (data) {
    return JSON.parse(data).serviceId;
  } else {
    return undefined;
  }
}

export function savePiiBrand(brand: string) {
  sessionStorage.setItem('mprdBrand', brand ? JSON.stringify(brand) : null);
}

export function getPiiBrand() {
  const data = sessionStorage.getItem('mprdBrand');
  if (data) {
    return JSON.parse(data);
  } else {
    return undefined;
  }
}

export function savePiiMyMobile(myMobile: boolean) {
  sessionStorage.setItem('myMobile', JSON.stringify(myMobile));
}

export function getPiiMyMobile() {
  const data = sessionStorage.getItem('myMobile');
  if (data && (data !== "undefined") && (data !== "")) {
    return JSON.parse(data);
  } else {
    return false;
  }
}

export function savePiiNsp(payload) {
  'use strict';
  sessionStorage.setItem('mprdNsp', JSON.stringify(payload));
}

export function getPiiNsp() {
  'use strict';
  const data = sessionStorage.getItem('mprdNsp');
  if (data) {
    return JSON.parse(data);
  } else {
    return undefined;
  }
}

export function savePiiProduct(payload) {
  'use strict';
  sessionStorage.setItem('mprdNewProduct', JSON.stringify(payload));
}

export function getPiiProduct() {
  'use strict';
  const data = sessionStorage.getItem('mprdNewProduct');
  if (data) {
    return JSON.parse(data);
  } else {
    return undefined;
  }
}

export function savePiiCloudServiceId(serviceId: string) {
  'use strict';
  const sessionStorageKey = piiHandler.setSessionStorageData(
    JSON.stringify({ serviceId: serviceId || '' }),
  );
  sessionStorage.setItem('mprdPiiCloud', sessionStorageKey);
}

export function getPiiCloudServiceId() {
  'use strict';
  const data = sessionStorage.getItem(sessionStorage.getItem('mprdPiiCloud'));
  if (data) {
    return JSON.parse(data).serviceId;
  } else {
    return undefined;
  }
}
